import Vue from 'vue'
import uuid from 'uuid/v1'
import midnightToday from '../utils/midnightToday'

export default defaults => Vue.observable({
  id: uuid(),
  title: '',
  date: midnightToday(),
  ...defaults
});
